import { Component, Inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MessageBoxComponent } from '../../components/message-box/message-box.component';
import { SafeHtmlPipe } from '../../pipes/safeHtml.pipe';

import { DialogRef } from '../../components/dialog/dialog-ref';
import { DIALOG_DATA } from '../../components/dialog/dialog.tokens';
import { DialogWrapperComponent, JeDialogTitleDirective } from '../../components/dialog/dialog-wrapper.component';
@Component({
    selector: 'je-info-window-dialog',
    imports: [TranslateModule, MessageBoxComponent, DialogWrapperComponent, JeDialogTitleDirective, SafeHtmlPipe],
    templateUrl: './info-window-dialog.component.html',
})
export class InfoWindowDialogComponent {
    constructor(
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA) public infoText: string,
    ) {}

    public onClose() {
        this.dialogRef.close();
    }
}
